/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type UseHasCabinSafetyCheckAlertVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  fccCurrentAdAlerts?: {
    __typename?: 'FccAdAlerts'
    alerts: Array<{
      __typename?: 'FccAdAlert'
      id: string
      type: Types.FccAdAlertType
      status: Types.FccAdAlertStatus
    }>
  } | null
}

export const UseHasCabinSafetyCheckAlertVehicleFragmentDoc = gql`
    fragment UseHasCabinSafetyCheckAlertVehicle on Vehicle {
  id
  fccCurrentAdAlerts @include(if: $withAdAlerts) {
    alerts {
      id
      type
      status
    }
  }
}
    `
